const SUCCESS = 'Success';
const FAILURE = 'Failure';

export {SUCCESS, FAILURE}


